export class DigitalDocumentType {
  constructor(id = 0, description = '', dpi = 100, width = 0, height = 0) {
    this.id = id;
    this.description = description;
    this.dpi = dpi;
    this.width = width;
    this.height = height;
  }
}
